export const MY_INCIDENTS_ICONS = [
  {
    text: "Conflict",
    value: "myincidents_conflict",
    fileName: "events_conflict_blue.png",
  },
  {
    text: "Crime",
    value: "myincidents_crime",
    fileName: "events_crime_blue.png",
  },
  {
    text: "Disasters",
    value: "myincidents_disasters",
    fileName: "events_disasters_blue.png",
  },
  {
    text: "Health",
    value: "myincidents_health",
    fileName: "events_health_blue.png",
  },
  {
    text: "Organized Crime",
    value: "myincidents_organized crime",
    fileName: "events_toc_blue.png",
  },
  {
    text: "Terrorism",
    value: "myincidents_terrorism",
    fileName: "events_terrorism_blue.png",
  },
  {
    text: "Transportation",
    value: "myincidents_transportation",
    fileName: "events_transportation_blue.png",
  },
  {
    text: "Travel",
    value: "myincidents_travel",
    fileName: "events_travel_blue.png",
  },
  {
    text: "Unrest",
    value: "myincidents_unrest",
    fileName: "events_unrest_blue.png",
  },
];
